import CustomerProfileContainer from './containers/CustomerProfileContainer';
import CustomerResetUNOrPWContainer from './containers/CustomerResetUNOrPWContainer';
import CustomerResetUsenameContainer from './containers/CustomerResetUsenameContainer';
import CustomerResetUserNameConfirmContainer from './containers/CustomerResetUNOrPWConfirmContainer/CustomerResetUserNameConfirmContainer';
import CustomerResetPasswordContainer from './containers/CustomerResetPasswordContainer';
import CustomerResetPasswordConfirmContainer from './containers/CustomerResetUNOrPWConfirmContainer/CustomerResetPasswordConfirmContainer';
import CustomerProfileVerifyContainer from './containers/CustomerProfileVerifyContainer';

import ChangeEmailContainer from './containers/ChangeEmailContainer';
import ChangeEmailApplyToOtherContainer from './containers/ChangeEmailApplyToOtherContainer';
import GoGreenContainer from './containers/GoGreenContainer';
import ReviewEmailContainer from './containers/ReviewEmailContainer';
import ChangeEmailConfirmContainer from './containers/ChangeEmailConfirmContainer';
import ChangeContactContainer from './containers/ChangeContactContainer';
import ContactDetailsContainer from './containers/ContactDetailsContainer';
import UpdateMobileContainer from './containers/UpdateMobileContainer';
import DownLoadFormContainer from './containers/DownLoadFormContainer';
import UpdateMobileGoGreenContainer from './containers/UpdateMobileGoGreenContainer';
import UpdateMobileApplyToOtherContainer from './containers/UpdateMobileApplyToOtherContainer';
import ReviewMobileContainer from './containers/ReviewMobileContainer';
import ChangeEmailVerifyContainer from './containers/ChangeEmailVerifyContainer';
import SubmitEmailErrorContainer from './containers/SubmitEmailErrorContainer';
import UpdateMobileVerifyContainer from './containers/UpdateMobileVerifyContainer';
import SubmitMobileErrorContainer from './containers/SubmitMobileErrorContainer';
import UpdateMobileConfirmContainer from './containers/UpdateMobileConfirmContainer';
import InsuredAccessContainer from './containers/InsuredAccessContainer';
import DeactivateAccessContainer from './containers/DeactivateAccessContainer';
import ErrorCodePageContainer from './containers/ErrorCodePageContainer/ErrorCodePageContainer';

import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import customerProfileSaga from './sagas';
import EditAddressContainer from './containers/EditAddressContainer';

import ReviewAddressContainer from './containers/ReviewAddressContainer';
import UpdateAddressApplyToOtherContainer from './containers/UpdateAddressApplyToOtherContainer';
import UpdateAddressConfirmContainer from './containers/UpdateAddressConfirmContainer';
import ChooseLocationContainer from './containers/ChooseLocation';
import RenewalUpdateContainer from './containers/RenewalUpdateContainer';
import AddressAbbreviationContainer from './containers/AddressAbbreviationContainer';

export default {
  config,
  routes: {
    '': {
      exact: true,
      // Moved to lazy loading config because it register lazy route instead of this one now.
      // sidebarItem: {
      //   label: t('CUSTOMER_PROFILE'),
      //   iconDefault: `/assets/images/customer-profile/customer-profile.svg`,
      //   iconSelected: `/assets/images/customer-profile/customer-profile-selected.svg`,
      // },
      container: CustomerProfileContainer,
    },
    '/changecontact': {
      exact: true,
      container: ChangeContactContainer,
    },
    '/renewalupdate/:policy_number': {
      exact: true,
      container: RenewalUpdateContainer,
    },
    '/renewalupdate/changeemail/edit': {
      exact: true,
      container: ChangeEmailContainer,
    },
    '/renewalupdate/changeemail/updatepolicy': {
      exact: true,
      container: ChangeEmailApplyToOtherContainer,
    },
    '/renewalupdate/changeemail/gogreen': {
      exact: true,
      container: GoGreenContainer,
    },
    '/renewalupdate/changeemail/review': {
      exact: true,
      container: ReviewEmailContainer,
    },
    '/renewalupdate/changeemail/verify': {
      exact: true,
      container: ChangeEmailVerifyContainer,
    },
    '/renewalupdate/changeemail/submiterror': {
      exact: true,
      container: SubmitEmailErrorContainer,
    },
    '/renewalupdate/changeemail/confirm': {
      exact: true,
      container: ChangeEmailConfirmContainer,
    },
    '/renewalupdate/changemobile/edit': {
      exact: true,
      container: UpdateMobileContainer,
    },
    '/renewalupdate/changemobile/updatepolicy': {
      exact: true,
      container: UpdateMobileApplyToOtherContainer,
    },
    '/renewalupdate/changemobile/gogreen': {
      exact: true,
      container: UpdateMobileGoGreenContainer,
    },
    '/renewalupdate/changemobile/review': {
      exact: true,
      container: ReviewMobileContainer,
    },
    '/renewalupdate/changemobile/verify': {
      exact: true,
      container: UpdateMobileVerifyContainer,
    },
    '/renewalupdate/changemobile/submiterror': {
      exact: true,
      container: SubmitMobileErrorContainer,
    },
    '/renewalupdate/changemobile/confirm': {
      exact: true,
      container: UpdateMobileConfirmContainer,
    },
    '/renewalupdate/errorcode/:feature_id/:error_code': {
      exact: true,
      container: ErrorCodePageContainer,
    },
    '/changeemail/edit': {
      exact: true,
      container: ChangeEmailContainer,
    },
    '/changeemail/updatepolicy': {
      exact: true,
      container: ChangeEmailApplyToOtherContainer,
    },
    '/changeemail/gogreen': {
      exact: true,
      container: GoGreenContainer,
    },
    '/changeemail/review': {
      exact: true,
      container: ReviewEmailContainer,
    },
    '/changecontact/downloadform': {
      exact: true,
      container: DownLoadFormContainer,
    },
    '/contactdetails/:policy_number': {
      exact: true,
      container: ContactDetailsContainer,
    },
    '/changeemail/verify': {
      exact: true,
      container: ChangeEmailVerifyContainer,
    },
    '/changeemail/submiterror': {
      exact: true,
      container: SubmitEmailErrorContainer,
    },
    '/changeemail/confirm': {
      exact: true,
      container: ChangeEmailConfirmContainer,
    },
    '/changemobile/edit': {
      exact: true,
      container: UpdateMobileContainer,
    },
    '/changemobile/updatepolicy': {
      exact: true,
      container: UpdateMobileApplyToOtherContainer,
    },
    '/changemobile/gogreen': {
      exact: true,
      container: UpdateMobileGoGreenContainer,
    },
    '/changemobile/review': {
      exact: true,
      container: ReviewMobileContainer,
    },
    '/changemobile/verify': {
      exact: true,
      container: UpdateMobileVerifyContainer,
    },
    '/changemobile/submiterror': {
      exact: true,
      container: SubmitMobileErrorContainer,
    },
    '/changemobile/confirm': {
      exact: true,
      container: UpdateMobileConfirmContainer,
    },
    '/reset': {
      exact: true,
      container: CustomerResetUNOrPWContainer,
    },
    '/reset/usename': {
      exact: true,
      container: CustomerResetUsenameContainer,
    },
    '/reset/usename/confirm': {
      exact: true,
      container: CustomerResetUserNameConfirmContainer,
    },
    '/reset/password': {
      exact: true,
      container: CustomerResetPasswordContainer,
    },
    '/reset/password/confirm': {
      exact: true,
      container: CustomerResetPasswordConfirmContainer,
    },
    '/reset/verify': {
      exact: true,
      container: CustomerProfileVerifyContainer,
    },
    '/insuredaccess': {
      exact: true,
      container: InsuredAccessContainer,
    },
    '/insuredaccess/deactivate': {
      exact: true,
      container: DeactivateAccessContainer,
    },
    '/errorcode/:feature_id/:error_code': {
      exact: true,
      container: ErrorCodePageContainer,
    },
    '/changeaddress/edit': {
      exact: true,
      container: EditAddressContainer,
    },
    '/changeaddress/review': {
      exact: true,
      container: ReviewAddressContainer,
    },
    '/changeaddress/confirm': {
      exact: true,
      container: UpdateAddressConfirmContainer,
    },
    '/changeaddress/updatepolicy': {
      exact: true,
      container: UpdateAddressApplyToOtherContainer,
    },
    '/changeaddress/chooselocation/:type': {
      exact: true,
      container: ChooseLocationContainer,
    },
    '/changeaddress/abbreviation': {
      exact: true,
      container: AddressAbbreviationContainer,
    },
  },
  sagas: customerProfileSaga,
} as ModuleConfig;
